<template>
    <div class="clients">

        <div class="clients__title">
            Clients
        </div>
        <div class="clients__subtitle">
            Recherche clients
        </div>
        <CustomFilter :filters="filters" />
        <template v-if="!isBusy">
            <template v-if="clients.data.length > 0">
                <div class="clients__table">
                    <div class="clients__table__item" v-for='client in clients.data'>
                        <div class="clients__table__item--cell">{{ parseClientFirstName(client) }}</div>
                        <div class="clients__table__item--cell">{{ client.last_name }}</div>
                        <div class="clients__table__item--cell">{{ client.email }}</div>
                        <div class="clients__table__item--cell">{{ client.tel }}</div>
                        <div class="clients__table__item--cell with-button">
                            <button class="edit" @click="editClient(client.id)">VISUALISER</button>
                        </div>
                        <div class="clients__table__item--cell with-button">
                            <button class="edit" @click="clientDocuments(client.id)">DOCS</button>
                        </div>
                    </div>
                </div>
                <pagination :data="clients" @pagination-change-page="getClients"></pagination>
            </template>
            <template v-else>
                <div class="subscribes-empty">Il n'y a aucun client pour ce type de garantie à ce jour.</div>
            </template>


        </template>
        <template v-else>
            <Preloader />
        </template>
    </div>
</template>

<script>
import CustomFilter from '@/components/Clients/CustomFilter';

export default {
    name: 'Clients',
    components: { CustomFilter },
    data() {
        return {
            clients: {
                data: []
            },
            filters: {
                first_name: '',
                last_name: '',
                email: '',
                tel: ''
            },
            isBusy: true,
        }
    },
    computed: {
        mechanic_id() {
            if (this.$store.getters.isSarrutAdmin) {
                return 4857;
            }
            else if (this.$store.getters.isSagaAdmin) {
                return 4870;
            }
            else
                return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
        }
    },
    watch: {
        'mechanic_id': function () {
            this.getClients();
        }
    },
    methods: {
        getClients(page = 1) {
            // if (this.mechanic_id) {
            this.isBusy = true;
            let url = 'client/search-partner?page=' + page,
                data = {
                    mechanic_id: this.mechanic_id,
                    ...this.getFilters(),
                    pdf: true
                };
            this.apiGet(url, data)
                .then(response => {
                    this.clients = response.data;
                    this.isBusy = false;
                })
                .catch(error => {
                    this.isBusy = false;
                    console.log(error);
                })
            // }
        },
        getFilters() {
            let data = {};
            this.filters.first_name ? data.first_name = this.filters.first_name : '';
            this.filters.last_name ? data.last_name = this.filters.last_name : '';
            this.filters.email ? data.email = this.filters.email : '';
            this.filters.tel ? data.tel = this.filters.tel : '';
            return data;
        },
        editClient(id) {
            this.$router.push('/client/' + id);
        },
        clientDocuments(id) {
            this.$router.push(`/client/${id}/documents`);
        },
        parseClientFirstName(client) {
            console.log('parseClientFirstName');
            console.log(client);
            if (+client.civility === 3) {
                return client.name_of_signatory;
            }
            return client.first_name;
        }
    },
    mounted() {
        this.getClients();
        this.$eventBus.$on('get-clients', this.getClients);

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Clients/Clients.vue